import { Tag, FavouriteObjectType } from "../../types/content";
import CardWithImageTopAndFooter from "./CardWithImageTopAndFooter";

export default function PeopleCard({
  objectId,
  objectType,
  image,
  bgColour = "",
  href,
  name,
  profession,
  synopsis,
  primaryTags,
  user,
  rating,
  reviews,
}: {
  objectId: string;
  objectType: FavouriteObjectType;
  image: string;
  bgColour?: string;
  href?: string;
  name: string;
  profession: string;
  synopsis: string;
  primaryTags: Tag[];
  user: any;
  rating: number;
  reviews: number;
}) {
  return (
    <CardWithImageTopAndFooter
      objectId={objectId}
      objectType={objectType}
      image={image}
      bgColour={bgColour}
      href={href}
      dataTitle={name}
      dataAuthor={name}
      dataTags={primaryTags.map((tag: any) => tag.name).join(", ")}
      middleContent={
        <>
          {/* Name */}
          <h1
            className="text-sm text-dark-blue font-bold line-clamp-1 overflow-hidden text-ellipsis break-words"
            title={name} // This sets the full text as the tooltip on hover
          >
            {name}
          </h1>

          {/* Profession */}
          <h1
            className="text-sm text-dark-blue font-bold line-clamp-1 overflow-hidden text-ellipsis break-words"
            title={profession} // This sets the full text as the tooltip on hover
          >
            {profession}
          </h1>

          {/* Synopsis */}
          <p title={synopsis} className="text-sm text-dark-blue line-clamp-2 overflow-hidden text-ellipsis break-words">{synopsis}</p>

          {/* Tags */}
          <div className="flex flex-wrap gap-[0.1rem]">
            {primaryTags.map((tag: Tag, index: number) => {
              return (
                <span key={`tag-${index}`} className="flex items-center bg-transparent border border-dark-blue text-dark-blue px-1.5 py-0.2 rounded-full text-xxs font-bold">{tag.name}</span>
              );
            })}
          </div>

        </>
      }
      footerContent={
        <>
          {/* Consumption */}
          <span className={`flex items-center text-white text-sm font-bold px-4 py-1 bg-yellow rounded-full`}>People</span>

        </>
      }
    />
  );
}
